import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {Strenger} from "../Strenger";
import {RessursFeilhåndtering} from "felles/tjenester/RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('KommentarRessurs');

export class KommentarRessurs extends BasisRessurs<l.KommentarModell> {

    static regNavn = "kommentarRessurs";

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            RessursFeilhåndtering.regNavn,
            Strenger.regNavn,
            regNavn.gettext.gettextCatalog,
            KommentarRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService,
                ressursFeilhåndtering: RessursFeilhåndtering,
                private strenger: Strenger,
                gettextCatalog: gettextCatalog) {
        super("kommentar",
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {
                registrerSvar: {method: 'PUT', url: "/api/kommentar/:id/svar"},
                slettSvar: {method: 'DELETE', url: "/api/kommentar/:id/svar/:svarId"},
                finnKommentarerDerJegDeltarIPerioden: {
                    method: 'GET',
                    url: "/api/kommentar/finnKommentarerDerJegDeltarIPerioden",
                    params: {id: ""},
                    isArray: true
                },
                finnKommentarerDerJegIkkeDeltarIPerioden: {
                    method: 'GET',
                    url: "/api/kommentar/finnKommentarerDerJegIkkeDeltarIPerioden",
                    params: {id: ""},
                    isArray: true
                }
            });
    }

    //offentlige metoder

    registrerSvar(kommentarId: string,
                  svar: string,
                  vedOk: (kommentar: l.KommentarModell) => void = _.noop): l.KommentarModell {
        debug("registrerSvar", kommentarId, svar);
        return this.ressurs["registrerSvar"](
            {id: kommentarId, svar: svar},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke registrere svar"))
        );
    }

    slettKommentar(kommentarId: string): l.OkRespons {
        return this.slett(kommentarId);
    }

    slettSvar(kommentarId: string, svarId: string): l.OkRespons {
        debug("slettSvar", kommentarId, svarId);
        return this.ressurs["slettSvar"](
            {id: kommentarId, svarId: svarId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke slette svar"))
        );
    }

    finnKommentarerDerJegDeltarIPerioden(start: Date, slutt: Date, vedOk: (kommentarer: l.KommentarModell[]) => void = _.noop): l.KommentarModell[] {
        debug("finnKommentarerDerJegDeltarIPerioden", start, slutt);
        return this.ressurs["finnKommentarerDerJegDeltarIPerioden"](
            {start: start, slutt: slutt},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne mine kommentarer"))
        );
    }

    finnKommentarerDerJegIkkeDeltarIPerioden(start: Date, slutt: Date, vedOk: (kommentarer: l.KommentarModell[]) => void = _.noop): l.KommentarModell[] {
        debug("finnKommentarerDerJegIkkeDeltarIPerioden", start, slutt);
        return this.ressurs["finnKommentarerDerJegIkkeDeltarIPerioden"](
            {start: start, slutt: slutt},
            vedOk,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke finne andres kommentarer"))
        );
    }

}
